// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import MasterService from '@services/masters'

export const getFeeType = createAsyncThunk('fee-type/getFeeType', async (params, { rejectWithValue }) => {
  try {
    const response = await MasterService.getAllFeeType(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getFeeTypeById = createAsyncThunk('fee-type/getFeeTypeById', async (id) => {
  const response = await MasterService.getFeeTypeById(id)
  return response
})

export const addFeeType = createAsyncThunk('fee-type/addFeeType', async (feeType, { rejectWithValue }) => {
  try {
    const response = await MasterService.addFeeType(feeType)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateFeeType = createAsyncThunk('fee-type/updateFeeType', async (feeType, { rejectWithValue }) => {
  try {
    const response = await MasterService.updateFeeType(feeType)
    return response
  } catch (err) {
    rejectWithValue(err.response.data)
  }
})

export const deleteFeetType = createAsyncThunk('fee-type/deleteFeeType', async (id, { dispatch, getState }) => {
  await MasterService.deleteFeeType(id)
  await dispatch(getFeeType(getState()?.feeTypes.params))
  return id
})

export const feeTypeSlice = createSlice({
  name: 'fee_type',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualFeeType: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFeeType.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getFeeTypeById.fulfilled, (state, action) => {
        state.individualFeeType = action.payload
        state.loading = false
      })
      .addCase(getFeeTypeById.pending, (state, action) => {
        state.individualFeeType = action.payload
        state.loading = true
      })
      .addCase(getFeeTypeById.rejected, (state, action) => {
        state.individualFeeType = action.payload
        state.loading = false
      })
  }
})

export default feeTypeSlice.reducer
